const DEFAULT_LOCALE = 'en'

function getDocumentLocale() {
  if (typeof document === 'undefined') return DEFAULT_LOCALE

  return document.documentElement?.lang || DEFAULT_LOCALE
}

function sanitizeLocale(locale) {
  return locale.toLowerCase().replace('_', '-')
}

// `locale` lets callers pass an explicit locale (e.g. a React prop available on both server and
// client). Without it, the locale is read from `document.documentElement.lang`, which is undefined
// during SSR and falls back to `en` - causing a hydration mismatch on non-default-locale pages.
function buildLocalizedPath(path = '/', locale) {
  const resolvedLocale = sanitizeLocale(locale || getDocumentLocale())
  const normalizedPath = path.startsWith('/') ? path : `/${path}`

  if (resolvedLocale === DEFAULT_LOCALE) {
    return normalizedPath
  }

  return `/${resolvedLocale}${normalizedPath}`
}

export { buildLocalizedPath }
